import { render, staticRenderFns } from "./AddProjectForm.vue?vue&type=template&id=ec806740"
import script from "./AddProjectForm.vue?vue&type=script&lang=js"
export * from "./AddProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports